import { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";

//import gasStationImage from "../Images/Gas_Station_Stock.jpg";
import gasStationImage from "../Images/Gas_Pump_Stock.jpg";
import hardHatImage from "../Images/HardHat_SafetyFirst_Stock.jpg";
import hardHatImage2 from "../Images/HardHat_Stock.png";
import logoImageWhite from "../Images/full-logo.png";
import ParticleBackground from "../ParticleBackground";


function Landing(props) {
  const [flipped, setFlippedStatus] = useState({
    ust: false,
    osha: false,
  });

  const [, setCourses] = useState([]);
  const [states, setStates] = useState([]);
  
  const toggleFlip = (key) => {
    setFlippedStatus(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const navigate = useNavigate();
  const goToStateCourse = () => {
    navigate('/state-course');
  };

  // Will reactivate once 
  const goToOSHACourse = () => {
    navigate('/osha-course');
  };

  const onClickMyCourses = () => {
    navigate("/mycourses");
  }
  const onClickMyCertificates = () => {
    navigate("/mycertificates");
  };

  useEffect(() => {
    axios.get("/extractCourses").then((res) => {
      const data = res.data;
      setCourses(data);

      const stateList = [
        ...new Set(
          data
            .map((c) => {
                  const match = c.name.match(/^(.*?)\s*petroleum/i);
                  return match ? match[1].trim() : null; // take everything before "petroleum"
                })
                .filter(Boolean) // remove nulls
            ),
      ].sort((a,b) => a.localeCompare(b));

      setStates(stateList)
    });
  }, []);

  return (
    
    <Container>
      <Space />
      <CompanySummary>
        <ParticleBackground />
        <LogoContainer>
          <Logo src={logoImageWhite} />
          <CatchPhrase>Teaching - Training - Technology</CatchPhrase>
          <CatchPhrase2>SAFETY TRAINING FOR THE DIGITAL AGE</CatchPhrase2>
        </LogoContainer>
      </CompanySummary>
      <Space />
      {  props.userInfo && (
        <NavWindow>
          <AltHeaderNav onClick={() => onClickMyCourses()}>Go to My Courses...</AltHeaderNav>
          <AltHeaderNav onClick={() => onClickMyCertificates()}>Go to My Certificates...</AltHeaderNav>
        </NavWindow>
      )}
      
      <MainContent>
        {/* UST TRAINING INFORMATION CARD*/}
        <Banner> Register For Training Today</Banner>
        <Card onClick={() => toggleFlip("ust")}>
          <CardInner flipped={flipped.ust}>
            {/* Landing Page default information */}
            <CardFront>
              <SubTitle>
                UST OPERATER TRAINING
              </SubTitle>
              <SubDescription bg={gasStationImage}>
                {/*<p>Enroll in Underground storage tank (UST) training
                   with Safet1st to meet EPA, federal, and state-level 
                   compliance for petroluem operations.
                <br /><br />
                • Become Certified Within The Day<br /><br />
                • Take Self Paced Modules<br /><br /> 
                • Offered in English, Spanish, Arabic, & Hindi<br /><br />
                • Ensure the Safety of Self & Business<br/><br />
                </p>*/}
              </SubDescription>
              <Link
                onClick={goToStateCourse}>
                <strong>Purchase Courses...</strong> 
              </Link>
            </CardFront>

            {/* Additional Information */}
            <CardBack>
              <BackTitle>
                Offered UST Petroleum Modules (By State)
              </BackTitle>
              <BackDescription>
                <ul>
                  <li>Alaska A/B/C</li>
                  <li>Arizona A/B</li>
                  <li>Colorado A/B</li>
                  <li>District of Columbia A/B</li>
                  <li>Florida A/B/C</li>
                  <li>Illinois A/B/C</li>
                  <li>Maryland A/B/C</li>
                  <li>Michigan A/B/C</li>
                  <li>Nevada A/B/C</li>
                  <li>Pennsylvania A/B</li>
                  <li>South Carolina A/B</li>
                  <li>South Dakota A/B</li>
                  <li>Utah A/B</li>
                  <li>Virginia A/B/C</li>
                  <li>West Virginia A/B/C</li>
                  <li>Wisconsin A/B</li>
                </ul>  
              </BackDescription>
            </CardBack>
          </CardInner>
        </Card>

        <Card onClick={() => toggleFlip("osha")}>
          <CardInner flipped={flipped.osha}>
            <CardFront>
              <SubTitle>
                Safety & Operator Training
              </SubTitle>
              <SubDescription bg={hardHatImage}>

              </SubDescription>
               {/* DAVIS FEEL FREE TO REIMPLEMENT ONCE OSCAR IS READY */}
              <Link onClick={goToOSHACourse}>
                <strong>Purchase Courses...</strong> 
              </Link>
            </CardFront>
            <CardBack>
              <BackTitle>
                Offered Safety Modules 
              </BackTitle>
              <BackDescription>
                • Traffic Regulator Training
              </BackDescription>
            </CardBack>
          </CardInner>
        </Card>
      </MainContent>
      <AboutUs>
        <AboutUsTitle
          bg={hardHatImage2}>
          <AboutUsQuote>
            <SmallQuote>About Us</SmallQuote>
            <h2>Your Safety Training Needs at the Intersection of Convenient & Committed</h2>
          </AboutUsQuote>
        </AboutUsTitle>

        <Banner2> 
          <h2>SAFET1ST</h2><br/>

          <p>Keep track of your <CourseLink onClick={goToOSHACourse}>AOSH Occupational Safety</CourseLink> and <CourseLink onClick={goToStateCourse}>Underground Storage Tank (UST) Operator</CourseLink> training certifications with our all-in-one digital 
             platform. Our easy-to-use interface provides self-paced, state-approved training and testing modules
             that track you and your team’s certifications online, sends expiration reminders, and helps ensure 
             you never fall out of compliance. Safety courses are  approved by the state and follows 
             an <i>only pay for what you need basis</i>, so no pesky subscriptions or spam emails, just the essentials. Additionally, use our inspection monitoring 
             software, <FuelProof href="https://fuelproofsoftware.com/">FuelProof</FuelProof>, to maintain detailed records of inspections, support your safety, stay in compliance,
             and help prevent legal or environmental disasters.
          </p><br/>

          <h2>UST OPERATOR TRAINING</h2> <br/>
          
          <p>
            We offer UST certification training in <Emphasis>{states.length > 1 ? states.slice(0, -1).join(", ") + ", and " + 
            states[states.length - 1] : states[0] || ""}.</Emphasis> We meet the standards for A, B and C class UST Operators. 
            Our courses are inclusive and accessible, currently offered in <Emphasis>English</Emphasis>, <Emphasis>Spanish</Emphasis>
            , <Emphasis>Arabic</Emphasis>, and <Emphasis>Farsi</Emphasis>. Pricing is as follows:
          </p><br/>
          <PriceList>
            <Emphasis>
            <p>•Class A Operator Training - $99.99</p>
            <p>•Class B Operator Training - $89.99</p>
            <p>•Class C Operator Training - $10.00</p>
            </Emphasis>
          </PriceList>
        </Banner2> 
      </AboutUs>
    </Container> 
  );
}

export default Landing;

const CourseLink = styled.a`
 color: black;
 text-decoration: underline;
 font-weight: bold;
 cursor: pointer;
`;

const FuelProof = styled.a`
 color: black;
 text-decoration: underline;
 font-weight: bold;
 `;

const Emphasis = styled.strong`
  color: white;
  font-size: 1.3rem;
  font-weight: bold;
`;

const NavWindow = styled.div`
  display: flex;
  flex-wrap: wrap; 
  gap: 1rem;
  justify-content: evenly-spaced;
  align-items: center;
  background-color: white;
  height: auto;
`;
const AltHeaderNav = styled.div`
  display: inline-flex;
  flex: 1 1 auto;     
  flex-shrink: 0;
  white-space: nowrap;
  min-width: max-content;
  justify-content: center;
  align-items: center;
  
  padding: 0.5rem 1rem;
  margin: 0 6rem 1.5rem 6rem;
  background-color: #30B354;  
  border-radius: 10px;
  color: white;
  font-size: 1.8rem;
  box-shadow: black 0px 5px 5px;
  cursor: pointer;
  
  transition: background-color 0.5s ease,
              color 0.5s ease,
              box-shadow 0.5s ease;
  &:hover {
    background-color: #3de26b;
    color: black;
    box-shadow: black 0px 15px 20px;
 }
`;


const AboutUs = styled.div`
  width: 100%;
`

const AboutUsTitle = styled.div`
  background-image: url(${props => props.bg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: inset 0 0 300px rgba(0, 0, 0, 0.8);
  
  color: black;

  @media (min-width: 850px) {
   height: 400px;
  }
  @media(max-width: 850px) {
    height: 55vh;
    color: white;
  }
`

const SmallQuote = styled.div`
  font-size: 1.2rem;
`
const AboutUsQuote = styled.div`
  padding: 12vw 35% 30px 5%;
  font-size: 1.8rem;
  text-shadow: 0 0 1px #ffffffb0;

  @media (max-width: 950px) {
    font-size: 1.5rem;
    text-shadow: 0 0 2px black;
    padding-right: 10%;
  }
`

const Banner2 = styled.div`
  background: linear-gradient(45deg, #30B354 0%,
                                     #258e42 60%,
                                     #124922 100%);
  color: #f2f2f2;
  padding: 5% 30% 5% 10%;
  font-size: 1.2rem;
  text-align: justify;

  @media (max-width: 850px) {
    padding: 5% ;
  }
`;

const PriceList = styled.div`
  padding-left: 50px;

  @media (max-width: 450px) {
    text-align: center;
    padding-left: 0px;
  }
`;

const Space = styled.div`
  padding-top: 50px;
  background-color: white;
`;

const Container = styled.div`
  background-color: #f2f2f2;
  margins: auto;
`;

const CompanySummary = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow: hidden;
  min-height: 300px;
  background-color: white;
`;

const LogoContainer = styled.div`
  width: fit-content;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0px 50px 0px;
`;
const Logo = styled.img`
  height: auto;
  width: 50rem;
  user-select: none;

  @media (max-width: 850px) {
    width: 94vw;
  }
`;
const CatchPhrase = styled.div`
  padding: 1.5%;
  margin-bottom: 2%;
  font-size: 2.7rem;
  width: 85%;
  text-align: justify;
  text-align-last: justify;
  user-select: none;

  @media (max-width: 850px) {
    font-size: 5vw;
  }

`;
const CatchPhrase2 = styled.div`
  background-color: #30B354;
  color: white;
  font-size: 1.8rem;
  padding: 5px 20px 5px 20px;
  border-radius: 10px;
  user-select: none;

  @media (max-width: 850px) {
    font-size: 3.4vw;
  }
`;

const Banner = styled.div`
  color: #30B354;
  padding: 1%;
  width: 100%;
  font-size: 2.7rem;
  font-weight: bold;
  text-align: center;
`;



const MainContent = styled.div`
  display: flex;
  background: linear-gradient(135deg, #cececeff 0%,
                                      #F2F2F2 30%,
                                      #FFFFFF 60%,
                                      #FFFFFF 100%);
  justify-content: center;
  gap: 1.5rem 5rem;
  flex-wrap: wrap;
  padding: 1% 3% 3% 3%;

  @media (max-width: 10px) {
    flex-direction: column;
    align-items: center;
    gap: 0.5rem 2rem; /* smaller gap on mobile */
  }
`;

const Card = styled.div`
  position: relative;
  width: 310px;
  min-height: 460px;
  perspective: 1000px;
`;

const CardInner = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease, box-shadow 0.3s ease;
  transform-style: preserve-3d;
  transform: ${props => (props.flipped ? "rotateY(180deg)" : "none")};

  box-shadow: 0px 5px 5px;
  border: 3px solid black;
  border-radius: 6px;
  background-color: black;

  &:hover {
    box-shadow: 0px 15px 20px;
  }
`;

const CardFront = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  backface-visibility: hidden;
  transform: rotateY(0deg);
  overflow: hidden;
`;

const SubTitle = styled.div`
  flex: 0 0 20%;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  background-color: black;
  color: white;
  font-size: 2rem;
  cursor:pointer;
`;

const SubDescription = styled.div`
  width: 100%;
  flex: 0 0 60%;
  padding: 15px;
  flex-direction: column;
  display: flex;
  position: relative;
  background-color: white;
  overflow: hidden;
  cursor:pointer;

  font-weight: bold;
  font-size: 0.93rem;
  text-align: justify;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${props => props.bg});
    background-size: cover;
    background-position: center;
    opacity: 0.33;
    z-index: 0;
  }
`;

const Link = styled.div`
  display: flex;
  flex: 0 0 20%;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 1rem;
  color: white;
  overflow: hidden;
  background-color: #258e42;
  cursor: pointer;
  border-radius: 0 0 3px 3px;
  transition: font-size 0.5s ease, 
              color 0.5s ease,  
              background-color 0.5s ease;
  
  &:hover {
    font-size: 1.05rem;
    font-color: black;
    background-color: #3de26b;
    color: black;
  }
`;

const CardBack = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotateY(180deg);
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const BackTitle = styled.div`
  width: 100%;
  flex: 0 0 20%;
  color: white;
  background-color: black;
  border-radius: 3px 3px 0 0;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  font-size: 1.8rem;
  cursor:pointer;
`;

const BackDescription = styled.div`
  width: 100%;
  flex-grow: 1;
  padding: 20px 40px 20px 40px;
  position: relative;
  background-color: white;
  border-radius: 0 0 3px 3px;
  overflow: hidden;
  display: flex;
  cursor:pointer;
  overflow-x: wrap;
  overflow-y: auto;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${props => props.bg});
    background-size: cover;
    background-position: center;
    opacity: 0.33;
    z-index: 0;
  }
`;